module.exports = __webpack_public_path__ + "img/img_promotion_hello_bg.9ab4f151.png";